import {
  MultidietSetupParamsType,
  MultidietSetupType,
} from '@/features/multidiet-picker/types/multidiet-setup.type';
import { GET } from '@/lib/methods';
import { objectToQueryString } from '@/lib/utilities';

export const getMultidietSetup = async ({
  params,
  queryParams,
}: {
  params?: RequestInit;
  queryParams?: MultidietSetupParamsType;
}): Promise<MultidietSetupType> => {
  const urlParams = objectToQueryString(queryParams);
  return GET<MultidietSetupType>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/multidiet/setup${urlParams}`,
    params: {
      next: {
        tags: [`multidiet-setup-${urlParams}`],
        revalidate: 60,
      },
      headers: {
        'Content-Type': 'application/json',
      },
      ...params,
    },
  });
};
